import Axios from 'axios';
import { SEND_MAIL_ERRORS } from 'queries/errors';
import { getUri } from 'utils/uri';

export class EmailErrorService {
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  static async sendMailError(data: any) {
    try {
      const uri = getUri(window.location.hostname);
      const headers = {
        'content-type': 'application/json',
        authorization: `Bearer ${localStorage.getItem('accessToken')}`,
      };
      await Axios({
        url: uri,
        method: 'POST',
        data: {
          query: SEND_MAIL_ERRORS,
          variables: {
            userId: data.user_id,
            userRole: data.user_role,
            userSites: data.user_sites,
            userEmail: data.user_email,
            userName: data.user_name,
            location: data.location,
            os: data.os,
            osVersion: data.os_version,
            browserVersion: data.browser_version,
            browserName: data.browser_name,
            error: data.error,
            errorInfo: data.error_info,
          },
        },
        headers,
      });
    } catch (error) {
      console.error(error);
    }
  }
}
